export const ShareEvent = () => {
  return <>ShareEvent</>;
};
